import { ISelect } from '@/interface/utils.model';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnChanges{
  @Input() control: AbstractControl = new FormControl();
  @Input() label: string = "";
  @Input() idForm: string;
  @Input() data: Array<any> = [];
  @Input() size: string = "";
  @Input() optValue: string = "";
  @Input() optText: string = "";
  @Input() default: boolean = false;
  @Input() defValue: string = "-1";
  @Input() defText: string = "Todo";
  @Output() returnSelectedText = new EventEmitter();
  obj: Array<ISelect>

  constructor(){
  }

  ngOnChanges(changes: SimpleChanges): void {    
    if (!this.data) return
    this.obj = this.data.map(val => <ISelect>{
      id: val[this.optValue],
      descripcion: val[this.optText]
    });    
  }

  returnText(obj){
    this.returnSelectedText.emit(obj.target.selectedOptions[0].label)
  }

}
